var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import classNames from "classnames";
import React, { useRef, useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { continuousSliderCls, continuousSliderSize300Cls, continuousSliderSize450Cls, continuousSliderDraggableCls, continuousSliderListCls, continuousSliderTrackCls, continuousSliderItemCls, continuousSliderArrowCls, continuousSliderPrevCls, continuousSliderNextCls, continuousSliderDisabledCls } from "./Slider.less";
function Slider(_ref, ref) {
  var className = _ref.className, children = _ref.children, _ref$draggable = _ref.draggable, draggable = _ref$draggable === void 0 ? false : _ref$draggable, _ref$height = _ref.height, height = _ref$height === void 0 ? 450 : _ref$height, _ref$resetScrollOnUpd = _ref.resetScrollOnUpdate, resetScrollOnUpdate = _ref$resetScrollOnUpd === void 0 ? false : _ref$resetScrollOnUpd, nextArrowText = _ref.nextArrowText, previousArrowText = _ref.previousArrowText, _ref$onSlide = _ref.onSlide, onSlide = _ref$onSlide === void 0 ? null : _ref$onSlide;
  var _useState = useState({
    scrollLeft: 0,
    showControls: false,
    disablePrev: true,
    disableNext: false,
    // initially draggable has to be set as false,
    // so that it works flawlessly both on server and client
    draggable: false
  }), _useState2 = _slicedToArray(_useState, 2), sliderState = _useState2[0], setSliderState = _useState2[1];
  var sliderListRef = useRef(null);
  var sliderTrackRef = useRef(null);
  var fixedHeight = parseInt(height, 10);
  var handleArrowClick = /* @__PURE__ */ __name(function handleArrowClick2(arrowType) {
    return function() {
      var _sliderListRef$curren = sliderListRef.current.getBoundingClientRect(), containerWidth = _sliderListRef$curren.width, containerX = _sliderListRef$curren.x;
      var _sliderTrackRef$curre = sliderTrackRef.current.getBoundingClientRect(), trackWidth = _sliderTrackRef$curre.width, trackX = _sliderTrackRef$curre.x;
      var trackXPos = containerX === trackX ? 0 : Math.abs(trackX) + containerX;
      var newPosition = 0;
      if (arrowType === "prev") {
        newPosition = trackXPos - containerWidth;
        newPosition = newPosition > 0 ? -newPosition : 0;
      } else {
        newPosition = trackXPos + containerWidth;
        newPosition = newPosition < trackWidth - containerWidth ? newPosition : trackWidth - containerWidth;
        newPosition = -newPosition;
      }
      var absNewPosition = Math.abs(newPosition);
      var newSlideState = _objectSpread(_objectSpread({}, sliderState), {}, {
        scrollLeft: newPosition,
        disablePrev: absNewPosition === 0,
        disableNext: absNewPosition >= trackWidth - containerWidth
      });
      if (typeof onSlide === "function") {
        onSlide(_objectSpread(_objectSpread({}, newSlideState), {}, {
          trackWidth,
          containerWidth
        }));
      }
      setSliderState(newSlideState);
    };
  }, "handleArrowClick");
  var handlePrevArrowClick = handleArrowClick("prev");
  var handleNextArrowClick = handleArrowClick("next");
  useEffect(function() {
    var _ref2 = sliderListRef.current && sliderListRef.current.getBoundingClientRect() || {}, containerWidth = _ref2.width;
    var _ref3 = sliderTrackRef.current && sliderTrackRef.current.getBoundingClientRect() || {}, trackWidth = _ref3.width;
    setSliderState(_objectSpread(_objectSpread({}, sliderState), {}, {
      scrollLeft: resetScrollOnUpdate ? 0 : sliderState.scrollLeft,
      disablePrev: resetScrollOnUpdate ? true : sliderState.disablePrev,
      disableNext: resetScrollOnUpdate ? trackWidth <= containerWidth : sliderState.disableNext,
      draggable,
      showControls: draggable === false && trackWidth > containerWidth
    }));
  }, [draggable, children]);
  useImperativeHandle(ref, function() {
    return {
      scrollToEnd: /* @__PURE__ */ __name(function scrollToEnd() {
        var _sliderListRef$curren2 = sliderListRef.current.getBoundingClientRect(), containerWidth = _sliderListRef$curren2.width;
        var _sliderTrackRef$curre2 = sliderTrackRef.current.getBoundingClientRect(), trackWidth = _sliderTrackRef$curre2.width;
        setSliderState(_objectSpread(_objectSpread({}, sliderState), {}, {
          disablePrev: false,
          disableNext: true,
          scrollLeft: trackWidth > containerWidth ? containerWidth - trackWidth : 0
        }));
      }, "scrollToEnd"),
      scrollToStart: /* @__PURE__ */ __name(function scrollToStart() {
        var _ref4 = sliderListRef.current && sliderListRef.current.getBoundingClientRect() || {}, containerWidth = _ref4.width;
        var _ref5 = sliderTrackRef.current && sliderTrackRef.current.getBoundingClientRect() || {}, trackWidth = _ref5.width;
        setSliderState(_objectSpread(_objectSpread({}, sliderState), {}, {
          scrollLeft: 0,
          disablePrev: true,
          disableNext: trackWidth <= containerWidth
        }));
      }, "scrollToStart")
    };
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(className, continuousSliderCls, sliderState.draggable && continuousSliderDraggableCls, _defineProperty(_defineProperty({}, continuousSliderSize300Cls, fixedHeight === 300), continuousSliderSize450Cls, !height || fixedHeight === 450))
  }, /* @__PURE__ */ React.createElement("div", {
    ref: sliderListRef,
    className: continuousSliderListCls
  }, /* @__PURE__ */ React.createElement("div", _extends({
    ref: sliderTrackRef,
    className: continuousSliderTrackCls
  }, !sliderState.draggable ? {
    style: {
      transform: "translate3d(".concat(sliderState.scrollLeft, "px, 0px, 0px)")
    }
  } : {}), React.Children.map(children, function(child, key) {
    return /* @__PURE__ */ React.createElement("div", {
      key,
      className: continuousSliderItemCls
    }, /* @__PURE__ */ React.cloneElement(child, child.props));
  }))), sliderState.showControls ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: classNames(continuousSliderArrowCls, continuousSliderPrevCls, sliderState.disablePrev && continuousSliderDisabledCls),
    onClick: handlePrevArrowClick
  }, previousArrowText), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: classNames(continuousSliderArrowCls, continuousSliderNextCls, sliderState.disableNext && continuousSliderDisabledCls),
    onClick: handleNextArrowClick
  }, nextArrowText)) : null);
}
__name(Slider, "Slider");
var ContinuousSlider = /* @__PURE__ */ forwardRef(Slider);
export {
  ContinuousSlider
};
